<p-panel header="Input / Output Registers" styleClass="ioregisters-panel">
  <div class="ioregisters-container">
    <p-table [value]="registerAddresses.sort()">
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: center;width: 55px">Addr.</th>
          <th style="text-align: center;">Name</th>
          <th style="text-align: center;width: 55px">Value</th>
        </tr>
      </ng-template>
      <ng-template let-address pTemplate="body">
        <tr class="source-code">
          <td>{{registersViewMap.get(address).strAddress}}</td>
          <td title="{{registersViewMap.get(address).description}}">{{registersViewMap.get(address).name}}</td>
          <td>{{registersViewMap.get(address).strValue}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-panel>
